import log from 'loglevel';

import { accessTokenService } from 'Util/Hooks/useAccessToken';

import { getDeviceInfo } from './Capacitors/SkooldioCapacitor';

const parseArg = (key, arg) => {
  if (typeof arg === 'string' && arg.startsWith('http')) {
    return `${key}=${arg}`;
  }
  return `${key}=${JSON.stringify(arg)}`;
};

export const argsToString = (args = {}) => {
  const keys = Object.keys(args);
  if (keys.length === 0) return '';
  return '?' + keys.map((key) => parseArg(key, args[key])).join('&');
};

const handleErrors = async (res, path) => {
  if (res.ok) return res;

  let error = new Error('Unknown Error');
  const respJson = await res.json();
  // switch (error.statusCode) {
  //   case 401:
  //     error = new Error('Forbidden');
  //     break;
  //   case 403:
  //     error = new Error('Forbidden');
  //     break;
  //   case 404:
  //     error = new Error('Not Found');
  //     break;
  //   case 422:
  //     break;
  //   case 500:
  //     error = new Error('Internal Server Error');
  //     break;
  //   default:
  // }
  error = new Error(respJson.error.message);
  error.name = respJson.error.name;
  error.details = respJson.error.details;
  error.response = res;
  error.statusCode = respJson.error.statusCode || res.status;

  throw error;
};

const parseValue = (res, parseAsJson = true, isRedirect = false, redirectFn) => {
  if (isRedirect && res.redirected) {
    redirectFn ? redirectFn(res) : window.open(res.url, '_blank');
    return res;
  }

  if (res.status === 204) return {};
  return parseAsJson ? res.json() : res.text();
};

function fetch2(
  path,
  params = null,
  method = METHOD.GET,
  body,
  fetchOptions = {
    parseJson: true,
    includeCredentials: true,
    includeContentType: true,
    isRedirect: false,
    isForceIncludeCredentials: false,
  },
  callbackFn = {
    handleRedirect: undefined,
    handleErrors: undefined,
  },
  timeout,
  customAccessToken
) {
  const { getAccessToken } = accessTokenService();
  const accessToken = getAccessToken() || customAccessToken;
  const options = {
    redirect: 'follow',
    method,
    headers: Object.assign(
      {},
      {
        Accept: 'application/json, text/plain, */*',
      }
    ),
  };
  if (accessToken) {
    options.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  if (fetchOptions.includeContentType) {
    options.headers['Content-Type'] = 'application/json';
  }
  if (fetchOptions.isForceIncludeCredentials) {
    options.credentials = 'include';
  } else if (fetchOptions.includeCredentials) {
    options.credentials = accessToken ? 'omit' : 'include';
  }
  if (body) {
    options.body = JSON.stringify(body);
  }

  const callPath = params ? `${path}${argsToString(params)}` : path;
  log.debug('url is ', method, callPath, body);

  return new Promise((resolve, reject) => {
    if (timeout) {
      setTimeout(() => {
        reject(new Error(`fetch path: ${callPath}, timeout(ms): ${timeout}`));
      }, timeout);
    }

    getDeviceInfo()
      .then((deviceInfo = {}) => {
        if (deviceInfo.uuid) {
          options.headers['x-forwarded-device-identity'] = deviceInfo.uuid;
        }

        fetch(callPath, options)
          .then((res) => resolve(res))
          .catch((error) => reject(error));
      })
      .catch((error) => reject(error));
  })
    .then((res) =>
      callbackFn.handleErrors ? callbackFn.handleErrors(res, callPath) : handleErrors(res, callPath)
    )
    .then((res) =>
      parseValue(res, fetchOptions.parseJson, fetchOptions.isRedirect, callbackFn.handleRedirect)
    )
    .catch((err) => {
      log.debug('err', err);
      throw err;
    });
}

export const retryWithDelay = (attemptFn, failAttemptFn, maxAttempt = 5, timeout = 3000) => {
  let attempts = 0;
  const execute = async () => {
    const isSuccess = await attemptFn();
    attempts++;
    if (!isSuccess) {
      if (maxAttempt && attempts >= maxAttempt) {
        typeof failAttemptFn === 'function' && failAttemptFn();
      } else {
        setTimeout(execute, timeout);
      }
    }
  };
  return execute();
};

export const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export default fetch2;
